export const NUMBER_ELEMENT_PER_PAGE = 10;
